import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { cioTrackPageChange } from '../utils.js';

/** Вызывает cioTrackPageChange при переходе по страницам
 */
export const useCioTrackPageChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    cioTrackPageChange();
  }, [pathname]);
};
